import { Box, Button, Typography, useTheme } from 'hephaestus/web';
import { ExpandMore as ExpandMoreIcon } from 'hephaestus/webIcons';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type WatchListHeaderProps = {
  approachingCount: number;
  expanded: boolean;
  onToggleExpanded: () => void;
  /** The band-consumed percentage threshold, e.g. 75. Used in the summary string. */
  approachThreshold: number;
};

export const WatchListHeader: FC<WatchListHeaderProps> = ({
  approachingCount,
  expanded,
  onToggleExpanded,
  approachThreshold,
}) => {
  const theme = useTheme();
  const { t } = useTranslation('watchList');

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
        py: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1.5,
        }}
      >
        <Typography variant='headingSmall'>{t('title')}</Typography>

        <Box
          sx={{
            px: 1,
            py: 0.25,
            borderRadius: 8,
            backgroundColor: theme.color.warningVariant,
            color: theme.color.onWarningVariant,
          }}
        >
          <Typography variant='labelSmall'>
            {t('header.approaching', { count: approachingCount })}
          </Typography>
        </Box>

        <Typography variant='bodySmall' color='textSecondary'>
          {t('header.thresholdSummary', { percent: approachThreshold })}
        </Typography>
      </Box>

      <Button
        variant='outlined'
        size='small'
        onClick={onToggleExpanded}
        endIcon={
          <ExpandMoreIcon
            sx={{
              transition: 'transform 200ms',
              transform: expanded ? 'rotate(180deg)' : 'none',
            }}
          />
        }
      >
        {expanded ? t('header.collapse') : t('header.expand')}
      </Button>
    </Box>
  );
};
